if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        // Select the form and related elements
        this.form = this.querySelector('form');
        this.variantIdInput = this.form.querySelector('[name=id]'); // Make sure the variant ID field is correctly selected
        this.variantIdInput.disabled = false;
        this.submitButton = this.querySelector('[type="submit"]');
        this.submitButtonText = this.submitButton.querySelector('span');
        this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        this.hideErrors = this.dataset.hideErrors === 'true';
        
        // Add event listener for form submission
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        
        if (document.querySelector('cart-drawer')) {
          this.submitButton.setAttribute('aria-haspopup', 'dialog');
        }
      }

      // Handle form submission
      onSubmitHandler(evt) {
        evt.preventDefault(); // Prevent the default form submit action
        if (this.submitButton.getAttribute('aria-disabled') === 'true') return; // Prevent double clicks

        this.handleErrorMessage(); // Clear previous error messages

        // Disable the button and show loading spinner
        this.submitButton.setAttribute('aria-disabled', true);
        this.submitButton.classList.add('loading');
        this.querySelector('.loading__spinner').classList.remove('hidden');

        const config = fetchConfig('javascript'); // Get fetch config for Shopify
        config.headers['X-Requested-With'] = 'XMLHttpRequest'; // Indicate that this is an AJAX request
        delete config.headers['Content-Type']; // Shopify expects no Content-Type header for form submissions

        const formData = new FormData(this.form);
        const formDataObject = {}; // Convert FormData to a simple object
        formData.forEach((value, key) => {
          formDataObject[key] = value;
        });

        // Log the data being sent for debugging
        console.log('Sending request to add product to cart...');
        console.log('Request body:', JSON.stringify(formDataObject));

        config.body = JSON.stringify(formDataObject); // Use JSON format for the body

        // Fetch request to add product to cart
        fetch(`${window.Shopify.routes.cart_add_url}`, config)
          .then((response) => {
            console.log('Cart response:', response);
            return response.json(); // Parse the JSON response
          })
          .then((response) => {
            console.log('Parsed Response:', response); // Log the parsed response

            if (response.status) {
              console.log('Cart error:', response.errors || response.description); // If there's an error, log it
              this.handleErrorMessage(response.description); // Show the error message
              
              // Show 'sold out' message if product is not available
              const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
              if (!soldOutMessage) return;
              this.submitButton.setAttribute('aria-disabled', true);
              this.submitButtonText.classList.add('hidden');
              soldOutMessage.classList.remove('hidden');
              this.error = true;
              return;
            }

            // If no error, update the cart UI with the new cart state
            console.log('Product added successfully:', response);

            if (!this.error) {
              publish(PUB_SUB_EVENTS.cartUpdate, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                cartData: response,
              });
            }

            this.error = false;
            this.cart.renderContents(response); // Refresh cart contents after adding product
          })
          .catch((e) => {
            console.error('Error adding product to cart:', e);
            this.handleErrorMessage('An error occurred while adding the product to the cart.'); // Show generic error message
          })
          .finally(() => {
            this.submitButton.classList.remove('loading');
            if (this.cart && this.cart.classList.contains('is-empty')) {
              this.cart.classList.remove('is-empty');
            }
            if (!this.error) {
              this.submitButton.removeAttribute('aria-disabled');
            }
            this.querySelector('.loading__spinner').classList.add('hidden');
          });
      }

      // Display error messages on the form
      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;
        this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }

      // Toggle the submit button state (enabled/disabled)
      toggleSubmitButton(disable = true, text) {
        if (disable) {
          this.submitButton.setAttribute('disabled', 'disabled');
          if (text) this.submitButtonText.textContent = text;
        } else {
          this.submitButton.removeAttribute('disabled');
          this.submitButtonText.textContent = window.variantStrings.addToCart;
        }
      }

      // Return the variant ID input element
      get variantIdInput() {
        return this.form.querySelector('[name=id]');
      }
    }
  );
}
